import { useEffect, useMemo } from 'react';
import { useUtxCurrenciesGetAll } from '../../../../../packages/utx-client/src/react';
import { ErrorCode } from '../enum';

export interface UseGetCurrenciesProps {
  assetList: AssetItem[];
  isLoading: boolean;
  refetch: () => void;
}

export interface AssetItem {
  id: number;
  label: string;
  value: string;
}

export const useBillPaymentCurrencies = (): UseGetCurrenciesProps => {
  // GET Currencies
  const queryCurrencies = useUtxCurrenciesGetAll({
    query: {
      enabled: false
    }
  });

  useEffect(() => {
    // run when init hooks
    queryCurrencies.refetch();
  }, []);

  useEffect(() => {
    if (queryCurrencies.error && queryCurrencies.error.response) {
      var statusCode: number | undefined = queryCurrencies.error.response.status;
      if (statusCode !== ErrorCode.EXPIRED_TOKEN_ERROR) {
        queryCurrencies.refetch();
      }
    }
  }, [queryCurrencies.error]);

  const assetList: AssetItem[] = useMemo(() => {
    if (!queryCurrencies?.data?.data) return [];
    const rawData = queryCurrencies.data.data;
    return rawData
      .filter((item) => item.active && item.type === 'currency')
      .sort((a, b) => (a.currencies_sequence > b.currencies_sequence ? 1 : -1))
      .map((item) => ({
        id: item.id,
        label: item.name,
        value: item.name
      }));
  }, [queryCurrencies]);

  const refetchBillPaymentCurrencies = () => {
    queryCurrencies.refetch();
  };

  const isLoadingBillPaymentCurrencies = useMemo(() => {
    return queryCurrencies.isLoading;
  }, [queryCurrencies.isLoading]);

  return {
    assetList: assetList,
    isLoading: isLoadingBillPaymentCurrencies,
    refetch: refetchBillPaymentCurrencies
  };
};
